import React from "react";

export default function Error() {
	return (
		<div className="d-flex flex-column  align-items-center h-100 w-100 pt-4">
			<h1 className="text-body">Something went wrong</h1>
			<p className="text-muted">There was a problem loading the widget.</p>
		</div>
	);
}
